import React from 'react';
import { renderFieldWithLinks } from 'utils/linkifyText';

interface ISingleResultRow {
  hit: any;
  tab: string;
  setShowFullRecord: any;
  showFilters: boolean;
}

const CyberRow: React.FC<ISingleResultRow> = ({
  hit,
  tab,
  setShowFullRecord,
}) => {
  const handleShowFullRecord = (fullHit: any) => {
    setShowFullRecord({ show: true, record: fullHit });
  };

  return (
    <div
      className='screening-results-row'
      onClick={() => handleShowFullRecord(hit)}
    >
      <div className='screening-results-row-checkbox-cell'></div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          {tab === 'Trade' && (
            <div className='screening-results-row-link-cell-text'>
              {hit?._source['Intervention Type']}
            </div>
          )}
          {tab === 'CVE' && (
            <div className='screening-results-row-link-cell-text'>
              {hit?._source['CVE ID']}
            </div>
          )}
          {tab === 'Markets' && (
            <div className='screening-results-row-link-cell-text'>
              {hit?._source['Market Name']}
            </div>
          )}
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          {tab === 'Trade' && (
            <div className='screening-results-row-default-cell-text'>
              {hit?._source['HS Code']}
            </div>
          )}
          {tab === 'CVE' && (
            <div className='screening-results-row-default-cell-text'>
              {hit?._source['Vendor Project']}
            </div>
          )}
          {tab === 'Markets' && (
            <div className='screening-results-row-default-cell-text'>
              {hit?._source.Description}
            </div>
          )}
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          {tab === 'Trade' && (
            <div className='screening-results-row-default-cell-text'>
              {hit?._source['Implementing Jurisdictions']}
            </div>
          )}
          {tab === 'CVE' && (
            <div className='screening-results-row-default-cell-text'>
              {hit?._source.Product}
            </div>
          )}
          {tab === 'Markets' && (
            <div
              className='screening-results-row-default-cell-text'
              // The row itself opens the full record on click — stop that
              // here so following the Website link doesn't also pop the
              // record drawer open behind the new tab.
              onClick={(e) => e.stopPropagation()}
            >
              {renderFieldWithLinks(String(hit?._source.Website ?? ''))}
            </div>
          )}
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          {tab === 'Trade' && (
            <div className='screening-results-row-default-cell-text'>
              {hit?._source['Risk Country']}
            </div>
          )}
          {tab === 'CVE' && (
            <div className='screening-results-row-default-cell-text'>
              {hit?._source['Vulnerability Name']}
            </div>
          )}
          {tab === 'Markets' && (
            <div className='screening-results-row-default-cell-text'>
              {hit?._source['Market Location']}
            </div>
          )}
        </div>
      </div>
      {tab === 'Trade' && (
        <div className='screening-results-row-default-cell'>
          <div className='screening-results-row-default-cell-inner'>
            {tab === 'Trade' && (
              <div className='screening-results-row-default-cell-text'>
                {hit?._source['GTA Evaluation']}
              </div>
            )}
          </div>
        </div>
      )}
      {tab === 'CVE' && (
        <div className='screening-results-row-default-cell'>
          <div className='screening-results-row-default-cell-inner'>
            {tab === 'CVE' && (
              <div className='screening-results-row-default-cell-text'>
                {hit?._source['Required Action']}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CyberRow;
